((w,d,$) => {
  $(() => {
    
    // 一覧整形
    const $list = $('.element_list .list_text'),
          $list_sp = $('.listContents .ui-listview'),
          item_layout = (i,item) => item_format( item, item_apart(item) ),
          item_layout_sp = (i,item) => item_format( item, item_apart_sp(item) ),
          item_apart = item => ({
            href: item.querySelector('h5>a').attributes.href.value.replace('main.php',''),
            catetitle: item.querySelector('.catetitle > a')||$('<a/>')[0],
            date: item.querySelector('.date'),
            new: item.querySelector('.new'),
            title: $('<h5>',{class:'title'}).text( $('h5>a',item)[0].innerText )[0],
            catch: item.querySelector('.catch'),
            body: $(item.querySelector('p:last-child')).addClass('body')[0]
          }),
          item_apart_sp = item => ({
            href: item.attributes.href.value.replace('main.php',''),
            catetitle: $('<a>').text(function(){
              const $p_cate = $('p',item).filter(function(){ return (/^\[(.+)\]$/).test(this.innerText) })
              if($p_cate) return $p_cate.addClass('catetitle').text().replace(/^\[(.+)\]/,'$1')
              else return ''
            })[0],
            date: $(item.querySelector('.dateTxt')).addClass('date'),
            new: item.querySelector('.new'),
            title: $('<h5>',{class:'title'}).text( $('h4',item)[0].innerText )[0],
            catch: item.querySelector('.discriptionTxt'),
            body: $(item.querySelector('p:not(.catetitle):not(.discriptionTxt):not(.listOption)')).addClass('body')[0]
          }),
          item_format = (item,apart) => {
            if(apart.new != undefined) apart.title = $(apart.title).append(apart.new)[0]
            if(apart.catetitle.innerText == '') apart.catetitle = false
            $(item).empty()
              .append('<div class="artloop__head" />')
              .append('<div class="artloop__body" />')
            $('.artloop__head',item)
              .append( apart.date )
              .append( (apart.catetitle)?$(apart.catetitle).addClass('button button-small button-border'):'' )
            $('.artloop__body',item)
              .append( apart.title )
              .append( apart.catch )
              .append( apart.body )
          }
    $list.find('.artloop').each(item_layout)
    $list_sp.children('li').find('a').each(item_layout_sp)
  })

})(window,document,jQuery);